import type { ICellRendererParams } from 'ag-grid-community';

import { useCrmUrl } from '@/utils/crm-url';

import { Row } from './columnDefs';

export function StrippingDonorCell({ value, data }: ICellRendererParams<Row>) {
  const crmUrl = useCrmUrl();
  if (!crmUrl) {
    return value;
  }
  if (!data) return null;

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10017');
  url.searchParams.set(
    'extraqs',
    'formid=b8caab64-5324-4038-808b-7fe7fb6a57af',
  );
  url.searchParams.set('id', `{${data.id}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
}
